const initProductCategoryForm = (el) => {
  const $el = $(el);

  const productCategories = $el.find('input[type="radio"]');
  const categoryListItems = $el.find(".product-category__item");

  productCategories.on("click", (event) => {
    let selectedCategory = $(event.currentTarget);

    categoryListItems.removeClass("active");
    categoryListItems.find('input[type="radio"]').prop("checked", false);

    selectedCategory.closest(".product-category__item").addClass("active");
    selectedCategory.prop("checked", true);
  });

  const mediaQuery = window.matchMedia("(max-width: 768px)");

  $el.on("submit", function (e) {
    e.preventDefault();

    const isMobile = mediaQuery.matches;
    let targetUrl;

    if (isMobile) {
      const selectedOption = $(e.target).find("option:selected");
      targetUrl = selectedOption.val();
    } else {
      const selectedInput = $(e.target).find('input[name="produkter"]:checked');
      targetUrl = selectedInput.data("url");
    }

    window.location.href = targetUrl;
  });
};

export default initProductCategoryForm;
